var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return (_vm.pageHasLeftBar)?_c('div',{attrs:{"id":"left-bar"}},[_c('div',{staticClass:"adaptive-column-content"},[_c(this.$route.meta.leftBarComponent,{tag:"component"})],1)]):_vm._e()}
var staticRenderFns = []

export { render, staticRenderFns }


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/loaders/templateLoader.js??vue-loader-options!./node_modules/vue-loader/lib??vue-loader-options!./src/blocks/LeftBar.vue?vue&type=template&id=636bef62&
// module id = 938
// module chunks = 0